export default __webpack_public_path__ + "static/media/icon-9.9d6c04af.png";